import {defaultIncomeVatOption, VatOptionSchema} from '@/vat/types/VatOptions'
import {z} from 'zod'
import {INCOME_ACCOUNT_NO} from '@/bookkeeping-account/accountTypes'
import {v4 as uuidv4} from 'uuid'

export const productLineNetPrice = (line: ProductLine): number => {
    return line.unitPrice * line.quantity * (1 - line.discount)
}

export const productLineVatAmount = (line: ProductLine): number => {
    return productLineNetPrice(line) * line.vatOption.rate
}

export const calculatedLinePrice = (line: ProductLine): number => {
    return productLineNetPrice(line) + productLineVatAmount(line)
}

export const ProductLineSchema = z.object({
    tempUuid: z.uuid(),
    productUuid: z.string(),
    productName: z.string(),
    customDescription: z.string().optional(),
    unitPrice: z.number(),
    quantity: z.number(),
    discount: z.number(),
    vatOption: VatOptionSchema,
    project: z.string().optional(),
    department: z.string().optional(),
    bookkeepingAccount: z.string(),
})

export type ProductLine = z.infer<typeof ProductLineSchema>

export const createProductLine = (): ProductLine => {
    const product = {
        tempUuid: uuidv4(),
        productUuid: '',
        productName: '',
        unitPrice: 0,
        quantity: 1,
        discount: 0,
        vatOption: defaultIncomeVatOption,
        bookkeepingAccount: INCOME_ACCOUNT_NO
    }
    return {...product}
}
